import React from 'react'
import { i18nText } from '../../../Services';

export const Paragraph = props => {
    const { element } = props;

    return (
        <>
            {i18nText.exists(element.text) && <p className={element.className}>{i18nText.getText(element.text)}</p>}
        </>        
    )
}

export default Paragraph;
